/**
 * Tier2Dialogues - Second Encounter & Exploration Dialogue Scripts
 * 
 * Dark Forest Portfolio Game
 * Pure data dictionary containing second-meeting dialogue lines for all 5 NPCs.
 * Displayed after the player has visited 1+ zones and completed the initial encounter.
 * Tone shifts to peer-to-peer reflection acknowledging cross-disciplinary growth.
 */

export const Tier2Dialogues = Object.freeze({
  mentor: Object.freeze([
    "You're back. I can see you've walked the forest.",
    "You're no longer a novice. You've seen what's possible.",
    "Did you notice how each zone connects to the others?",
    "Full-stack work requires web foundations. Data work requires mathematical thinking.",
    "Mobile apps bring it all together—databases, interfaces, real-world constraints.",
    "You're beginning to see the whole picture. The forest reveals itself to the patient.",
    "Keep going. There are still depths you haven't reached."
  ]),

  fullstack: Object.freeze([
    "You've returned. And you've seen other domains since we last spoke.",
    "That's wise. A full-stack developer needs perspective.",
    "EduVault taught you backend logic. CodeXcape taught you interactivity.",
    "But web development isn't just about code. It's about user experience, about building bridges between data and people.",
    "The best developers I know have dabbled in other fields. It makes them better at their core skill.",
    "You're becoming one of those developers.",
    "What have you learned from the other zones?"
  ]),

  ada: Object.freeze([
    "You've explored beyond the data forest. Interesting choice.",
    "I wondered if you'd see the value in my work at first glance, or if you'd need to understand the broader context.",
    "Data science doesn't exist in isolation. It powers web apps. It optimizes mobile experiences. It informs decisions everywhere.",
    "Your sentiment analysis work was solid. But now you see how it fits into a larger landscape.",
    "That's the mark of a good researcher—understanding where your work connects to everything else.",
    "Come back when you've seen it all. I suspect we'll have much to discuss."
  ]),

  mobilearch: Object.freeze([
    "Welcome back, developer. You've seen more of the world since we met.",
    "GMMX is just one app. But it's proof you understand modern development.",
    "Flutter, Firebase, real-time data—these are skills that matter now.",
    "I've noticed developers who jump between mobile, web, and data work often have the strongest fundamentals.",
    "You're building a polymath skillset. That's valuable in ways you might not realize yet.",
    "The app ecosystem needs developers who understand the full stack. Not specialists. Generalists with depth.",
    "Keep exploring."
  ]),

  futureyou: Object.freeze([
    "You're getting closer. You've walked more paths now.",
    "I can see the growth. Each zone has taught you something.",
    "Web development showed you how to build systems. Data science showed you how to understand them. Mobile showed you how to distribute them.",
    "These aren't separate skills. They're facets of the same craft.",
    "When you've seen all the zones, we'll talk again. There's more I need to tell you.",
    "But not yet. You're not ready to understand it all.",
    "Keep walking."
  ])
});

export default Tier2Dialogues;
